import { DEFAULT_THEME, HORIZONTAL_TEMPLATE } from '@anm/constants/videoLandings';
import capitalize from '@anm/helpers/string/capitalize';
import { useSelector } from 'react-redux';

import vtConfigs from '../../../../config';
import { landingsSelectors } from '../../../../store/modules/landings';
import { userSelectors } from '../../../../store/modules/user';

const { selectLandingTheme, selectLandingLayout } = landingsSelectors;

const { paidVideoLandingsThemes, paidVideoLandingsLayouts } = vtConfigs();

const usePaidThemeAndLayout = () => {
  const theme = useSelector(selectLandingTheme) || DEFAULT_THEME;
  const layout = useSelector(selectLandingLayout) || HORIZONTAL_TEMPLATE;
  const landingSettings = useSelector(userSelectors.selectUserLandingsSettings);

  const canUsePaidThemes = landingSettings?.premiumThemes;
  const canUsePaidLayouts = landingSettings?.premiumLayouts;

  const paidThemes = canUsePaidThemes ? [] : paidVideoLandingsThemes;
  const paidLayouts = canUsePaidLayouts ? [] : paidVideoLandingsLayouts;

  const isThemePaid = paidThemes.includes(theme);
  const isLayoutPaid = paidLayouts.includes(layout);

  const shouldUpgrade = isThemePaid || isLayoutPaid;

  const descriptionStart = isThemePaid ? `${capitalize(theme)} theme` : `This layout`;

  const upgradeDescription = shouldUpgrade ? `${descriptionStart} available only for premium subscriptions` : '';

  return {
    paidThemes,
    paidLayouts,
    shouldUpgrade,
    upgradeDescription
  };
};

export default usePaidThemeAndLayout;
